import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadSupportUsersSuccessAction, supportUsersActionTypes} from '../actions/support-users';
import {SupportUsers} from '../models/support-users';
export interface SupportUsersState {
  array: SupportUsers[];
}

const initialState: SupportUsersState = {
  array: []
};

export function supportUsersReducer(state: SupportUsersState = initialState, action: Action): SupportUsersState {
  switch (action.type) {
    case supportUsersActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: SupportUsersState, action: LoadSupportUsersSuccessAction): SupportUsersState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}


export const supportUsersSelectors = {
  array: (state: SupportUsersState) => _.get(state, 'array', []),

};
